import { ContentStateInterface } from '../../../@types/types'
import { DispatchType } from '../../../@types/redux-types'
import { tracking } from '../../../tracking/tracking'
import { saveAndProgress } from './saveAndProgress'
import { insertionUpdateRequest } from '../../reducers/insertion/insertionFeature'
import { InitState } from '../../reducers/root/initialState'
import { getDefaultLogger } from '../../../services/logger/logger'

export const doSave = (insertionData: ContentStateInterface, isSubmitBtnClicked: boolean) => {
  return async (dispatch: DispatchType, getState: () => InitState) => {
    dispatch(insertionUpdateRequest())
    getDefaultLogger().info('doSave', { isSubmitBtnClicked })

    isSubmitBtnClicked &&
      tracking({
        flowInformation: getState().flowFeature.flowInformation,
        eventName: 'submit_complete_button_click',
        entryMode: getState().insertionFeature.insertionIdentification.metaInformation?.entryMode,
        moreEventParameters: {
          ga_cd_realestate_object_id: getState().insertionFeature.insertionIdentification.realEstateId?.toString(),
        },
      })
    insertionData.isHomeStreetHomeEnabled &&
      isSubmitBtnClicked &&
      tracking({
        eventName: 'form_submit_homelesspeople_active',
        flowInformation: getState().flowFeature.flowInformation,
      })
    await saveAndProgress(insertionData, isSubmitBtnClicked)(dispatch, getState)
  }
}
